<template>
  <section class="blood-distribution-section">
    <h2>จำนวนเลือดในระบบ แบ่งตามกรุ๊ปเลือด</h2>
    <container>
      <div class="col-sm-12 col-md-6 dog-distribution">
        <div class="row">
          <div class="col-2">
            <img class="blood-distribution-img" src="@/assets/other/dog-outline.png" alt="dog outline red">
          </div>
          <div class="col-10">
            <bar-chart
              :bloodData="dogBloodDistribution"
              :chartHeight="250"
              :unitLabel="chartUnitLabel"/>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 cat-distribution">
        <div class="row">
          <div class="col-10">
            <bar-chart
              :bloodData="catBloodDistribution"
              :chartHeight="250"
              :unitLabel="chartUnitLabel"/>
          </div>
          <div class="col-2">
            <img class="blood-distribution-img" src="@/assets/other/cat-outline.png" alt="cat outline red">
          </div>
        </div>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'
import BarChart from '@/components/BarChart.vue'

export default {
  name: 'BloodDistributionSection',
  data () {
    return {
      dogBloodDistribution: [],
      catBloodDistribution: [],
      chartUnitLabel: 'units'
    }
  },
  mounted () {
    var validBloodCollection = this.$store.getters.getValidBloodCollection
    if (validBloodCollection.length === 0) {
      this.$store.dispatch('getBloodCollectionData').then(() => {
        this.updateBloodDistribution()
      })
    } else {
      this.updateBloodDistribution()
    }
  },
  methods: {
    updateBloodDistribution () {
      var dogBloodDistribution = []
      var catBloodDistribution = []
      for (var blood of this.$store.getters.getValidBloodCollection) {
        if (!blood.blood_group) {
          blood.blood_group = 'ไม่ระบุ'
        }
        if (blood.pet_type.toLowerCase().indexOf('dog') !== -1) {
          var dogGroup = dogBloodDistribution.find(b => b.type === blood.blood_group)
          if (dogGroup) {
            dogGroup.units += 1
          } else if (blood.blood_group) {
            dogBloodDistribution.push({
              type: blood.blood_group,
              units: 1,
              barHeight: 0
            })
          }
        } else if (blood.pet_type.toLowerCase().indexOf('cat') !== -1) {
          var catGroup = catBloodDistribution.find(b => b.type === blood.blood_group)
          if (catGroup) {
            catGroup.units += 1
          } else if (blood.blood_group) {
            catBloodDistribution.push({
              type: blood.blood_group,
              units: 1,
              barHeight: 0
            })
          }
        }
      }
      this.dogBloodDistribution = dogBloodDistribution
      this.catBloodDistribution = catBloodDistribution
    }
  },
  components: {
    Container,
    BarChart
  }
}
</script>

<style scoped lang="scss">
.blood-distribution-section {
  padding: 2rem 0;
  .cat-distribution {
    margin-top: 1rem;
  }
  h2 {
    text-align: center;
    margin-bottom: 1rem;
    padding: 0 1rem;
    font-size: $h3-font-size;
  }
  .blood-distribution-img {
    bottom: 3.5rem;
    position: absolute;
    left: 0;
    width: 100%;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .blood-distribution-section {
    h2 {
      margin-bottom: 2rem;
      font-size: $h2-font-size;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "md")) {
  .blood-distribution-section {
    .cat-distribution {
      margin-top: 0;
    }
    .dog-distribution {
      border-right: 1px solid $gray-500;
    }
  }
}
</style>
